import { Pipe, PipeTransform } from '@angular/core';
import { human } from '../tools/human-currency';

@Pipe({name: 'human'})
export class humanPipe implements PipeTransform {
  transform(value: number, displayCents: boolean = false): string {
    return human(value, displayCents);
  }
}